import gql from 'graphql-tag';

import formTemplateFragment from '~/shared/graphql-queries/form-templates/form-template-fragment';

export default gql`
  mutation createOneFormTemplateMutation($record: CreateOneFormTemplateInput!) {
    createOneFormTemplateMutation(record: $record) {
      recordId
      record {
        ...FormTemplateFragment
      }
      message
      title
    }
  }
  ${formTemplateFragment}
`;
